import { Button } from "@skydio/rivet-ui";

interface InviteEnableFooterProps {
  disabledSubmit?: boolean;
  submitText: string;
  onClickSubmit: () => void;
  onClickCancel: () => void;
}

export const InviteEnableFooter = ({
  disabledSubmit,
  onClickSubmit,
  onClickCancel,
  submitText,
}: InviteEnableFooterProps) => {
  return (
    <div className="flex items-center justify-between p-3">
      <span />
      {/* //TODO(jeremys): uncomment below once import is implemented; also remove above span */}
      {/* <Tooltip title={t("inviteModal.importTooltip")}>
                  <Upload beforeUpload={handleImport} fileList={[]}>
                    <Button className="flex items-center justify-center">
                      {t("inviteModal.buttons.import")}
                    </Button>
                  </Upload>
                </Tooltip> */}
      <div className="flex space-x-4">
        <Button onPress={onClickCancel}>Cancel</Button>
        <Button variant="primary" isDisabled={disabledSubmit} onPress={onClickSubmit}>
          {submitText}
        </Button>
      </div>
    </div>
  );
};

interface UserProfileFooterProps {
  disabledSubmit?: boolean;
  submitText: string;
  onClickSubmit: () => void;
  onClickCancel: () => void;
}

export const UserProfileFooter = ({
  disabledSubmit,
  onClickSubmit,
  onClickCancel,
  submitText,
}: UserProfileFooterProps) => {
  return (
    <div className="flex items-center justify-between p-3">
      <span />
      <div className="flex space-x-4">
        <Button onPress={onClickCancel}>Cancel</Button>
        <Button variant="primary" isDisabled={disabledSubmit} onPress={onClickSubmit}>
          {submitText}
        </Button>
      </div>
    </div>
  );
};
